import http from './http'
//
/**
 *  @parms resquest 请求地址 例如：http://197.82.15.15:8088/request/...
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */

// get请求
// export function getUserInfoAjax() {
//     return http.get('/myHomePage/getUserInfo', )
// }

export function getUserSig() {
    return http.get('/teacherReply/getUserSig', )
}

export function getStuUserInfo() {
    return http.get('/stuBase/info', )
}

export function endMeetingAjax(data) {
    return http.post('/teacherReply/endMeeting',data )
}

export function getUserInfoAjax(data){
    return http.get('/teacherReply/getUserInfo',data)
}

//获取当前会议是否在录制
export function getRecordStatusAjax(data){
    return http.post('/teacherReply/getRecordStatus',data)
}

//开始录制
export function beginRecordAjax(data){
    return http.post('/teacherReply/beginRecord',data)
}

//结束录制
export function endRecordAjax(data){
    return http.post('/teacherReply/endRecord',data)
}

// 切换支持人

export function changeHostAjax(data){
    return http.post('/teacherReply/changeHost',data)
}